import React from "react";
import { Link, type LinkProps, useHref, useLocation } from "react-router-dom";
import { isProfileHref } from "../../utils/profileModalNavigation";
import { useProfileGlobalModal } from "./ProfileGlobalModalContext";

/**
 * Same as {@link Link}, but in-app `/profile` targets open the global profile overlay without changing the URL.
 * When already on `/profile` or `/edit-profile`, uses normal client navigation so the route updates.
 */
export function ProfileLink({ to, state, onClick, replace, ...rest }: LinkProps) {
  const href = useHref(to);
  const location = useLocation();
  const { openProfileFromHref } = useProfileGlobalModal();

  if (!isProfileHref(href)) {
    return <Link to={to} state={state} onClick={onClick} replace={replace} {...rest} />;
  }

  if (location.pathname === "/profile" || location.pathname === "/edit-profile") {
    return <Link to={to} state={state} onClick={onClick} replace={replace} {...rest} />;
  }

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    onClick?.(e);
    if (e.defaultPrevented) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    e.preventDefault();
    openProfileFromHref(href);
  };

  return <a href={href} onClick={handleClick} {...(rest as React.AnchorHTMLAttributes<HTMLAnchorElement>)} />;
}
